//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CarouselCategories from "~/components/objects/CarouselCategories.vue";
import MainInteresting from "~/components/MainInteresting.vue";
import MainFacts from "~/components/MainFacts.vue";
import MainAbout from "~/components/MainAbout.vue";
import MainExperts from "~/components/MainExperts.vue";
import MainQuotes from "~/components/MainQuotes.vue";
import MainObjects from "~/components/MainObjects.vue";
import MainArts from "~/components/MainArts.vue";
import MainEncyclopediaCategories from "~/components/MainEncyclopediaCategories.vue";
import MainEvents from "~/components/MainEvents.vue";
// import MainSameObjects from "~/components/MainSameObjects.vue";

export default {
  name: "ObjectsList",
  components: {
    'objects-carousel-categories': CarouselCategories,
    'main-interesting': MainInteresting,
    'main-facts': MainFacts,
    'main-about': MainAbout,
    'main-experts': MainExperts,
    'main-quotes': MainQuotes,
    'main-objects': MainObjects,
    'main-arts': MainArts,
    'main-encyclopedia-categories': MainEncyclopediaCategories,
    // 'main-events': MainEvents,
    // 'main-same-objects': MainSameObjects,
  },
  layout: "public_new",
  async asyncData({ store, query }) {
    await Promise.allSettled([
      store.dispatch('async_fetch_data/fetchDataHeader'),
      store.dispatch('categories/getNavTreeDetail'),
    ]);

    const promises = [
      store.dispatch('art/fetchMaterialCategories'),
      store.dispatch('objects/getMainFacts'),
      store.dispatch('art/getMainArts'),
      store.dispatch('objects/getMainObjects'),
      // store.dispatch('objects/getMainEvents'),
      store.dispatch('objects/fetchFooterStats'),
      store.dispatch('async_fetch_data/fetchDataInteresting'),
      // store.dispatch('same_objects/getMainObjects'),
    ];

    const [results, topExperts] = await Promise.all([
      Promise.allSettled(promises),
      store.dispatch('users/fetchTopExperts', { limit: 9 }).catch(() => []),
    ]);

    results.forEach((result, index) => {
      if (result.status === 'rejected') {
        console.error(`Error loading data from promise ${index}:`, result.reason);
      }
    });

    return { topExperts }
  },
  data() {
    return {
      categories: [],
      headImage: '',
      headTitle: `ViStat.Org - Интерактивная инфографика, схемы, иллюстрации. Искусство, техника, космос, оружие, архитектура.`,
      isDataLoaded: false,
      topExperts: [],
    }
  },
  head() {
    return {
      title: this.headTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.headDescription
        },
        { hid: 'og:title', name: 'og:title', content: this.headTitle },
        { hid: 'og:image', name: 'og:image', content: this.headImage },
        { hid: 'og:description', name: 'og:description', content: this.headDescription },
        { hid: 'og:site_name', name: 'og:site_name', content: 'ViStat.ORG - Интерактивная инфографика.' },
      ]
    }
  },
  computed: {
    mainQuotes() {
      const payload = this.$store.getters['objects/getMainQuotes']
      return Array.isArray(payload?.items) ? payload.items : (Array.isArray(payload) ? payload : [])
    },
    headDescription() {
      return 'Познавательные статьи, интересные факты, важные события в удобной форме: графика, диаграммы, схемы и визуальные списки.'
    },
  },
  beforeMount() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      this.headImage = document.URL.slice(0, -1) + require('~/assets/img/new-logo-full.png')
    }
  },
  mounted() {
    this.isDataLoaded = true;
    this.$store.dispatch('objects/getMainQuotes')
  },
}
